import { createContext, useContext } from 'react';
import { EntitySchemaApiId } from '@/model/EntitySchema.model';
import { EntitySchemaV1 } from '@/model/EntitySchema.model';

export interface EntitySchemaContextResponse {
  entityFields: Array<EntitySchemaV1>;
  entityLoading: boolean;
  entityUpdating: boolean;
  setFieldRequired: (apiId: EntitySchemaApiId, required: boolean) => Promise<void>;
  hasEntityError: boolean;
}

export const EntitySchemaContext = createContext<EntitySchemaContextResponse | undefined>(undefined);

export const useEntitySchemaContext = (): EntitySchemaContextResponse => {
  const context = useContext(EntitySchemaContext);
  if (!context) {
    throw new Error('useEntitySchemaContext must be used within EntitySchemaProvider');
  }
  return context;
};
